<template>
    <div>
        <div class="mb-5">
            <h3>{{ __('connectors.stores') }}</h3>
            <div>
                <div class="row">
                    <div class="col-4">
                        <label>{{ __('connectors.label.store_uuid') }}</label>
                    </div>
                    <div class="col-3">
                        <label>{{ __('connectors.label.name') }}</label>
                    </div>
                    <div class="col-3">
                        <label>{{ __('connectors.label.id') }}</label>
                    </div>
                </div>

                <div class="row">
                    <div class="col-4">
                        <span class="form-text text-muted">{{ __('connectors.label.description.store_uuid') }}</span>
                    </div>
                    <div class="col-3">
                        <span
                            class="form-text text-muted">{{ __('connectors.label.description.name') }}</span>
                    </div>
                    <div class="col-3">
                        <span class="form-text text-muted">{{ __('connectors.label.description.id') }}</span>
                    </div>
                </div>
                <div v-for="store in stores" class="row mt-2">
                    <div class="col-4">
                        <input class="form-control" type="text" placeholder="Store-UUID" v-model="store.store_uuid"
                               required>
                    </div>
                    <div class="col-3">
                        <input class="form-control" type="text" placeholder="Name"
                               v-model="store.name" required>
                    </div>
                    <div class="col-3">
                        <input class="form-control" type="text" placeholder="Händler Store-ID"
                               v-model="store.store_identifier"
                               :disabled="storeCount === 1">
                    </div>
                    <div class="col-2">
                        <div class="d-flex flex-row justify-content-end">
                            <button class="btn btn-light-warning" @click="edit(store.settings, store.store_uuid)" v-if="!forAllStores" >
                                <i class="fas fa-edit"/>
                            </button>
                            <button class="btn btn-light-danger" :disabled="storeCount === 1" @click="removeStore(store)">
                                <i class="fas fa-trash"/>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="mt-3" v-if="!hasStores">
                    <Link as="button" :href="$route('stores.create')" class="btn btn-default mt-3 h-40px">
                        <i class="fas fa-plus-square"></i>
                        {{ __('navigation.create_store') }}
                    </Link>
                </div>
                <div class="mt-3" v-else>
                    <div class="checkbox-inline">
                        <label class="checkbox checkbox-lg">
                            <input type="checkbox" v-model="forAllStores">
                            <span></span>{{ __('connectors.label.description.for_all_stores') }}</label>
                    </div>
                </div>
            </div>
        </div>

        <hr>

        <div class="my-5">
            <h3>{{ __('connectors.title') }}</h3>
            <span class="form-text text-muted" v-show="!forAllStores && form.store_uuid">{{ form.store_uuid }}</span>
            <div>
                <div class="row">
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.delimiter') }}</label>
                        <input class="form-control" type="text" placeholder="Delimiter" maxlength="1"
                               v-model="form.delimiter">
                        <span class="form-text text-muted">{{ __('connectors.label.description.delimiter') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.enclosure') }}</label>
                        <input class="form-control" type="text" placeholder="Enclosure" maxlength="1"
                               v-model="form.enclosure">
                        <span class="form-text text-muted">{{ __('connectors.label.description.enclosure') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.header_offset') }}</label>
                        <input class="form-control" type="number" placeholder="Header Offset"
                               v-model="form.header_offset">
                        <span class="form-text text-muted">{{ __('connectors.label.description.header_offset') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.column_name') }}</label>
                        <div class="checkbox-inline">
                            <label class="checkbox checkbox-lg">
                                <input type="checkbox" v-model="form.no_column_names">
                                <span></span>{{ __('connectors.label.no_column_name') }}</label>
                        </div>
                        <span class="form-text text-muted">{{ __('connectors.label.description.column_name') }}</span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.gtin') }}</label>
                        <input class="form-control" type="text" placeholder="EAN-Spalte" v-model="form.header_map.gtin">
                        <span class="form-text text-muted">{{ columnType }} {{ __('connectors.label.description.gtin') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.price') }}</label>
                        <input class="form-control" type="text" placeholder="Preis-Spalte"
                               v-model="form.header_map.price">
                        <span class="form-text text-muted">{{ columnType }} {{ __('connectors.label.description.price') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.quantity') }}</label>
                        <input class="form-control" type="text" placeholder="Bestand-Spalte"
                               v-model="form.header_map.quantity">
                        <span class="form-text text-muted">{{ columnType }} {{ __('connectors.label.description.quantity') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.store_id') }}</label>
                        <input class="form-control" type="text" placeholder="Store-ID-Spalte"
                               v-model="form.header_map.store_identifier"
                               :disabled="storeCount === 1">
                        <span class="form-text text-muted">{{ columnType }} {{ __('connectors.label.description.store_id') }}</span>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.files') }}</label>
                        <input class="form-control" type="text" placeholder="Dateien" v-model="form.files">
                        <span class="form-text text-muted">{{ __('connectors.label.description.files') }}</span>
                    </div>
                    <div class="col-6 col-md-3">
                        <label>{{ __('connectors.label.article_name') }}</label>
                        <input class="form-control" type="text" placeholder="Custom-Artikel-Id-Spalte" v-model="form.header_map.in_store_article_id">
                        <span class="form-text text-muted">{{ __('connectors.label.description.article_name') }}</span>
                    </div>
                </div>
            </div>
            <div class="mt-5 text-danger" v-if="errors !== {}">
                <div v-for="(items, error) in errors">
                    <strong>{{ error }}</strong><br>
                    <div v-for="e in items">{{ e }}</div>
                </div>
            </div>

            <div class="mt-5 pt-3">
                <button class="btn btn-primary" :class="{'spinner spinner-white spinner-left': loading}" @click="submit">
                    {{ hasConnectors ? __('actions.connectors_refresh') : __('actions.connectors_create') }}
                </button>
            </div>
        </div>

        <hr>

        <div class="mt-5">
            <h3>{{ __('connectors.source') }}</h3>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{ __('connectors.label.typ') }}</label>
                        <div></div>
                        <select class="custom-select form-control" v-model="form.source" disabled>
                            <option disabled selected="selected">{{ __('connectors.label.description.typ') }}</option>
                            <option value="ftp">FTP</option>
                            <option value="url">URL</option>
                            <option value="manually">Manuell</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row" v-if="form.source === 'url'">
                <div class="col">
                    <label>{{ __('connectors.label.url') }}</label>
                    <input class="form-control" type="text" placeholder="https://..." v-model="form.url">
                    <span class="form-text text-muted">{{ __('connectors.label.description.url') }}</span>
                </div>
            </div>
            <div class="row" v-if="form.source === 'ftp'">
                <div class="col-6 col-md-3">
                    <label>{{ __('ftp.label.host') }}</label>
                    <input class="form-control" type="text" placeholder="ftp.youbuyda.com" v-model="form.host" disabled>
                    <span class="form-text text-muted">{{ __('connectors.label.description.ftp.host') }}</span>
                </div>
                <div class="col-6 col-md-3">
                    <label>{{ __('ftp.label.user') }}</label>
                    <input class="form-control" type="text" placeholder="User" v-model="form.user" disabled>
                    <span class="form-text text-muted">{{ __('connectors.label.description.ftp.user') }}</span>
                </div>
                <div class="col-6 col-md-3">
                    <div class="form-group">
                        <label class="font-weight-bold">{{ __('ftp.label.password') }}</label>
                        <div class="input-group">
                            <input :type="showPassword ? 'text' : 'password'" class="form-control" type="text" placeholder="Passwort" v-model="form.password" disabled>
                            <div class="input-group-append">
                                <button class="btn btn-secondary" type="button" @click="showPassword = !showPassword">
                                    <span class="fa-solid" :class="{ 'fa-eye' : !showPassword, 'fa-eye-slash' : showPassword}"></span>
                                </button>
                            </div>
                        </div>

                        <span class="form-text text-muted">{{ __('connectors.label.description.ftp.password') }}</span>
                    </div>
                </div>
                <div class="col-6 col-md-3">
                    <label>{{ __('ftp.label.dir') }}</label>
                    <input class="form-control" type="text" placeholder="Verzeichnis" v-model="form.ftp_dir" disabled>
                    <span class="form-text text-muted">{{ __('connectors.label.description.ftp.dir') }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditFtpConnector',

    props: {
        initStores: Array,
        ftpAccount: Object,
        hasConnectors: Boolean
    },

    data() {
        return {
            loading: false,
            errors: {},
            stores: [],
            form: {
                delimiter: ';',
                enclosure: '',
                header_offset: 0,
                files: 1,
                no_column_names: true,
                source: 'ftp',
                host: 'ftp.youbuyda.com',
                user: '',
                password: '',
                ftp_dir: '',
                url: '',
                header_map: {
                    gtin: 'ean',
                    price: 'price',
                    quantity: 'quantity',
                    store_identifier: 'store_id',
                    in_store_article_id: 'in_store_article_id'
                },
                store_uuid: null
            },
            forAllStores: false,
            showPassword: false
        }
    },

    mounted() {
        this.$nextTick(() => {
            if (this.hasStores) {
                this.stores = this.initStores;
                if (this.hasOneStore) {
                    this.forAllStores = true;
                    if (this.stores[0].settings) {
                        this.form = this.stores[0].settings;
                    }
                }
                if (this.ftpAccount) {
                    this.form.user = this.ftpAccount.username;
                    this.form.password = this.ftpAccount.password;
                    this.form.ftp_dir = this.ftpAccount.username;
                }
            }
        })
    },

    computed: {
        storeCount: function() {
            return this.stores.length
        },
        columnType: function() {
            return this.form.no_column_names ? 'Index' : 'Name'
        },
        hasStores: function() {
            return this.initStores.length > 0;
        },
        hasOneStore: function() {
            return this.initStores.length === 1;
        }
    },

    methods: {
        removeStore(storeToRemove) {
            if (this.stores.length === 1) {
                return
            }

            let stores = []
            for (let store of this.stores) {
                if (storeToRemove !== store) {
                    stores.push(store)
                }
            }
            this.stores = stores
        },
        edit(settings, store_uuid) {
            if (settings) {
                this.form.delimiter = settings.delimiter;
                this.form.enclosure = settings.enclosure;
                this.form.header_offset = settings.header_offset;
                this.form.files = settings.files;
                this.form.no_column_names = settings.no_column_names;
                this.form.source = 'ftp';
                this.form.ftp_dir = settings.ftp_dir;
                this.form.header_map.gtin = settings.header_map.gtin;
                this.form.header_map.price = settings.header_map.price;
                this.form.header_map.quantity = settings.header_map.quantity;
                this.form.header_map.store_identifier = settings.header_map.store_identifier;
                this.form.header_map.in_store_article_id = settings.header_map.in_store_article_id;
            }
            this.form.store_uuid = store_uuid;
        },
        async submit() {
            if (this.loading) {
                return
            }

            this.errors = {}
            this.loading = true
            await axios.post(route('ftp.connector.edit'), {
                stores: this.stores,
                form: this.form,
            }, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            }).then(() => {
                toastr.success(__('connectors.toast_message.updated'))
            }).catch(error => {
                toastr.error(__('connectors.toast_message.fail'));
                this.errors = error.response.data.errors
            })
            this.loading = false
        },
    },
}
</script>
